module.exports = __webpack_public_path__ + "static/icon-round-hands-c8311823f3e99be77252a24c7d03586b.svg";